import { render, staticRenderFns } from "./RoomView.vue?vue&type=template&id=97fde452&scoped=true"
import script from "./RoomView.vue?vue&type=script&lang=js"
export * from "./RoomView.vue?vue&type=script&lang=js"
import style0 from "./RoomView.vue?vue&type=style&index=0&id=97fde452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97fde452",
  null
  
)

export default component.exports